import Img from "gatsby-image";
import styled from "styled-components";

const BackgroundImg = styled(Img)`
  height: 0;
  padding-bottom: ${props => (props.mobileRatio || 2 / 3) * 100 + "%"};

  @media (min-width: 40em) {
    padding-bottom: ${props => (props.ratio || 1 / 3) * 100 + "%"};
  }

  & > img {
    object-fit: ${props => props.fit || "cover"} !important;
    object-position: ${props => props.position || "50% 50%"} !important;
    font-family: 'object-fit: ${props =>
      props.fit || "cover"} !important; object-position: ${props =>
  props.position || "50% 50%"} !important;'
  }
`;

export default BackgroundImg;
